<dx-data-grid
  id="gridContainer"
  [dataSource]="customStore"
  [allowColumnReordering]="true"
  [allowColumnResizing]="true"
  [columnAutoWidth]="true"
  [columnMinWidth]="100"
  [width]="'100%'"
  [columnResizingMode]="'widget'"
  [showBorders]="true"
  [rowAlternationEnabled]="updateGrid?.rowSelection ? false : true"
  [showColumnLines]="true"
  [showRowLines]="true"
  [filterValue]="filterValue"
  [remoteOperations]="remoteOperations ? remoteOperations : false"
  [hoverStateEnabled]="updateGrid?.rowSelection"
  (onSelectionChanged)="onSelectionChanged($event)"
  (onRowPrepared)="onRowPrepared($event)"
  (onCellPrepared)="onCellPrepared($event)"
  (onContentReady)="contentReady($event)"
  (onExporting)="onExporting($event)">
  <dxo-load-panel [enabled]="false"></dxo-load-panel>
  <dxo-filter-panel [visible]="false"></dxo-filter-panel>
  <dxo-paging [pageSize]="currentPageSize"></dxo-paging>
  <dxo-pager
    [visible]="true"
    [allowedPageSizes]="[10, 25, 50, 100]"
    [displayMode]="displayMode"
    [showPageSizeSelector]="true"
    [showInfo]="true"
    [showNavigationButtons]="true"></dxo-pager>
  <!--end pagination-->

  <dxo-export [enabled]="enableExport" [formats]="['xlsx', 'csv']"></dxo-export>

  <dxo-filter-builder [customOperations]="customOperations"> </dxo-filter-builder>
  <dxo-filter-builder-popup [position]="popupPosition"> </dxo-filter-builder-popup>

  <dxo-filter-row [visible]="showHeaderFilter" [applyFilter]="currentFilter"></dxo-filter-row>
  <dxo-header-filter [visible]="true" [allowSearch]="false"></dxo-header-filter>
  <dxo-selection mode="single" *ngIf="updateGrid?.rowSelection"></dxo-selection>
  <ng-container *ngFor="let column of columns; let i = index">
    <ng-container *ngIf="column?.hide !== true">
      <ng-container *ngIf="column?.link; else noLink">
        <dxi-column
          [visible]="getVisabilityByChoosableProp(updateGrid?.chooser, column?.visible)"
          [allowHiding]="!column?.Choosable"
          [fixed]="column?.fixed"
          [dataField]="column?.columnDef"
          [filterOperations]="column?.filterOperations ? column?.filterOperations : ''"
          [caption]="column?.header"
          [allowFiltering]="column?.filter"
          cellTemplate="cellTemplate"
          [allowSorting]="column?.sort"
          [sortOrder]="getSortOrder(updateGrid?.defaultSortColumn, updateGrid?.defaultSortType, column?.columnDef)">
          <dxo-header-filter [dataSource]="customizeHeaderFilterData"></dxo-header-filter>
        </dxi-column>
      </ng-container>
      <ng-template #noLink>
        <ng-container *ngIf="column?.icon; else noIcon">
          <dxi-column
            [visible]="getVisabilityByChoosableProp(updateGrid?.chooser, column?.visible)"
            [allowHiding]="!column?.Choosable"
            [fixed]="column?.fixed"
            [dataField]="column?.columnDef"
            [caption]="column?.header"
            [allowFiltering]="column?.filter"
            [filterOperations]="column?.filterOperations ? column?.filterOperations : ''"
            cellTemplate="iconTemplate"
            [allowSorting]="column?.sort"
            [sortOrder]="getSortOrder(updateGrid?.defaultSortColumn, updateGrid?.defaultSortType, column?.columnDef)">
            <dxo-header-filter [dataSource]="customizeHeaderFilterData"></dxo-header-filter>
          </dxi-column>
        </ng-container>
      </ng-template>
      <ng-template #noIcon>
        <ng-container *ngIf="column?.dateFormat; else noDate">
          <dxi-column
            [visible]="getVisabilityByChoosableProp(updateGrid?.chooser, column?.visible)"
            [allowHiding]="!column?.Choosable"
            [fixed]="column?.fixed"
            *ngIf="column?.dateFormat === 'date' || column?.dateFormat === 'datetime'"
            [dataField]="column?.columnDef"
            [caption]="column?.header"
            [allowFiltering]="column?.filter"
            [filterOperations]="column?.filterOperations ? column?.filterOperations : ''"
            dataType="date"
            [format]="getDateFormat(column?.dateFormat)"
            [allowSorting]="column?.sort"
            [sortOrder]="getSortOrder(updateGrid?.defaultSortColumn, updateGrid?.defaultSortType, column?.columnDef)">
            <dxo-header-filter [dataSource]="customizeHeaderFilterData"></dxo-header-filter>
          </dxi-column>
        </ng-container>
      </ng-template>
      <ng-template #noDate>
        <dxi-column
          [dataField]="column.columnDef"
          [caption]="column.header"
          [filterOperations]="column?.filterOperations ? column?.filterOperations : ''"
          [allowFiltering]="column.filter">
          <dxo-header-filter [dataSource]="customizeHeaderFilterData"></dxo-header-filter>
        </dxi-column>
        <ng-container *ngIf="column?.header.toLowerCase().trim() === 'status'; else noStatus">
          <dxi-column
            [visible]="getVisabilityByChoosableProp(updateGrid?.chooser, column?.visible)"
            [allowHiding]="!column?.Choosable"
            [fixed]="column?.fixed"
            [dataField]="column?.columnDef"
            [filterOperations]="column?.filterOperations ? column?.filterOperations : ''"
            [caption]="column?.header"
            [allowFiltering]="column?.filter"
            cellTemplate="statusTemplate"
            [allowSorting]="column?.sort"
            [sortOrder]="getSortOrder(updateGrid?.defaultSortColumn, updateGrid?.defaultSortType, column?.columnDef)">
            <dxo-header-filter [dataSource]="customizeHeaderFilterData"></dxo-header-filter>
          </dxi-column>
        </ng-container>
      </ng-template>
    </ng-container>
  </ng-container>
  <ng-container
    *ngIf="
      updateGrid &&
      (updateGrid?.externalLink ||
        updateGrid?.openPopup ||
        updateGrid?.edit ||
        updateGrid?.editMyApplication ||
        updateGrid?.editAppeal ||
        updateGrid?.editBilling ||
        updateGrid?.delete ||
        updateGrid?.delete ||
        updateGrid?.download ||
        updateGrid?.showDownload ||
        updateGrid?.showDelete ||
        updateGrid?.pdf)
    ">
    <dxi-column
      [width]="100"
      [allowFiltering]="false"
      [allowSorting]="false"
      caption="Action"
      cellTemplate="editCellTemplate"></dxi-column>
    <!-- Action label added for admin grid -->

    <div *dxTemplate="let d of 'editCellTemplate'">
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.externalLink"
        class="no-bg"
        matTooltip="Open"
        (click)="openLink(d)">
        <em class="fa fa-external-link" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="Appeal"
        *ngIf="updateGrid?.appeal"
        class="no-bg"
        matTooltip="Appeal"
        (click)="navigateTo(d)">
        <em class="fa fa-external-link" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.showDownload && !updateGrid?.isNewlyUploaded"
        class="no-bg"
        matTooltip="Download File"
        (click)="downloadFormResponseAttachments(d)">
        <em class="fa fa-download" aria-hidden="true"></em> </a
      >&nbsp;&nbsp;
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.showDelete"
        class="no-bg text-danger"
        matTooltip="Delete File"
        (click)="deleteFormResponseAttachments(d)">
        <em class="fa fa-trash" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.openPopup"
        class="no-bg"
        matTooltip="Open"
        (click)="openPopupLink(d)">
        <em class="fa fa-newspaper-o" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.duplicate"
        class="no-bg mr-2"
        matTooltip="Copy"
        (click)="duplicateDate(d)">
        <em class="fa fa-copy" aria-hidden="true" fieldKey="PAG_DES_GRID_LIST_COPY"
          ><span class="sr-only">Copy</span></em
        >
      </a>
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.download"
        class="no-bg"
        matTooltip="Download"
        (click)="downloadData(d)">
        <em class="fa fa-download" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="Edit"
        *ngIf="updateGrid?.edit && !d.data?.extendedProps?.outcome"
        class="no-bg mr-2"
        matTooltip="Edit"
        (click)="editData(d)">
        <em class="fa fa-pencil" title="Edit" aria-hidden="true" style="font-size: 13px"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="Edit"
        *ngIf="updateGrid?.editMyApplication && d?.data?.application_status === 'In Progress'"
        class="no-bg mr-2"
        matTooltip="Edit"
        (click)="editDataMyApplciation(d)">
        <em class="fa fa-pencil" title="Edit" aria-hidden="true" style="font-size: 13px"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="Edit"
        *ngIf="updateGrid?.editAppeal && d?.data?.status === 'In Progress'"
        class="no-bg mr-2"
        matTooltip="Edit"
        (click)="editAppeal(d)">
        <em class="fa fa-pencil" title="Edit" aria-hidden="true" style="font-size: 13px"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="Edit"
        *ngIf="updateGrid?.editBilling && d?.data?.status === 'Waiting for approval'"
        class="no-bg mr-2"
        matTooltip="Edit"
        (click)="editAppeal(d)">
        <em class="fa fa-pencil" title="Edit" aria-hidden="true" style="font-size: 13px"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="View"
        *ngIf="updateGrid?.view"
        class="no-bg mr-2"
        matTooltip="View"
        (click)="viewData(d)">
        <em class="fa fa-eye" title="View" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        title="delete"
        *ngIf="updateGrid?.delete"
        class="no-bg text-danger"
        matTooltip="Delete"
        (click)="deleteData(d)">
        <em class="fa fa-trash" aria-hidden="true"></em>
      </a>
      <a
        href="javascript:void(0)"
        *ngIf="updateGrid?.outcome && d.data?.extendedProps?.outcome"
        class="no-bg"
        matTooltip="View"
        (click)="outComeData(d)">
        <em class="fa fa-eye" title="View" aria-hidden="true"></em>
      </a>
      <a href="javascript:void(0)" title="pdf" *ngIf="updateGrid?.pdf" class="no-bg" matTooltip="PDF">
        <em class="fa fa-file-pdf-o" aria-hidden="true"></em>
      </a>
      <button
        *ngIf="updateGrid?.toggle"
        class="no-bg"
        [matTooltip]="d.data.isactive === true ? 'Deactivate' : 'Activate'"
        (click)="activeUser(d)">
        <em *ngIf="updateGrid?.toggle && d.data.isactive === true" class="fa fa-toggle-on"></em>
        <em *ngIf="updateGrid?.toggle && d.data.isactive === false" class="fa fa-toggle-off"></em>
      </button>
      <button *ngIf="updateGrid?.activeordeactive" class="no-bg" (click)="deleteData(d)">
        <em *ngIf="updateGrid?.activeordeactive && d.data.activeflag === 1" class="fa fa-toggle-on"></em>
        <em *ngIf="updateGrid?.activeordeactive && d.data.activeflag === 0" class="fa fa-toggle-off"></em>
      </button>
    </div>
  </ng-container>
  <div *dxTemplate="let d of 'cellTemplate'">
    <a href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" (click)="getRouter(d)">{{
      d.value !== 'null' ? d.value : ''
    }}</a>
  </div>
  <ng-container *ngIf="updateGrid.linkVisible">
    <div *dxTemplate="let d of 'cellTemplate'"  (click)="navigateLink($event, d)">
      <a *ngIf="d.value && d.value !== 'null'" [innerHTML]="d.value | safeHtml">{{
        d.value !== 'null' ? d.value : ''
      }}</a>
    </div>
  </ng-container>
  <div *dxTemplate="let d of 'iconTemplate'">
    <em class="fa fa-book" (click)="popup(d.value)" aria-hidden="true"></em>
  </div>
</dx-data-grid>
<ng-template #callNarrativePopup>
  <h2 matDialogTitle>Narrative</h2>
  <div [innerHTML]="narrativeData"></div>
  <div class="text-right">
    <button mat-button (click)="closeNarrativePopup()" class="btn btn-cancel mr-2">Close</button>
  </div>
</ng-template>
